import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { Flex } from 'components/base/layout-components';
import { PERIODS } from '../periods/constants';
import { StyledMenuItem } from '../PeriodPicker.style';

const StyledMenu = styled(Flex)`
  border-right: 1px solid ${getColor('silverSand')};
  padding-right: 1px;
  height: 100%;
`;

const StyledMenuItemsList = styled(Flex)`
  min-width: 12rem;
`;

/**
 * Period menu component props
 * @typedef {object} PeriodMenuProps
 * @property {string[]} hiddenPeriods A list of periods that will be hidden
 */

/**
 * Periods menu component
 * @param {PeriodMenuProps} props
 * @returns {JSX.Element}
 */
const PeriodsMenu = ({
  disabledPeriods,
  selectedPeriod,
  setSelectedPeriod,
  hiddenPeriods = []
}) => {
  const { periodKey } = selectedPeriod;

  const items = Object.entries(PERIODS)
    .map(([key, value = {}]) => {
      if (hiddenPeriods.includes(key)) {
        return false;
      }

      const { menuName } = value;
      const isSelected = periodKey === key;
      const isDisabled = disabledPeriods.includes(key);

      return (
        <StyledMenuItem
          key={key}
          selected={isSelected}
          disabled={isDisabled}
          onClick={() => {
            setSelectedPeriod(value);
          }}
        >
          {menuName}
        </StyledMenuItem>
      );
    })
    .filter(Boolean);

  return (
    <StyledMenu>
      <StyledMenuItemsList direction='column' data-testid='period-picker-menu'>
        {items}
      </StyledMenuItemsList>
    </StyledMenu>
  );
};

export default PeriodsMenu;
